import Vue from 'vue';
import Vuetify from 'vuetify/lib';
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#f4813f",
        secondary: "#f1556a",
        theme: "#FFFFFF",
        light_primary: '#F8B38B'
      },
      dark: {
        primary: "#f4813f",
        secondary: "#f1556a",
        theme: "#000000"
      },
    },
  },
});